// validation constants for attachment view
export const ATTACHMENT_REFERENCE_DOCUMENT_MAX_SIZE_KB = 1024 * 2; // 2MB
export const ATTACHMENT_REFERENCE_DOCUMENT_ALLOWED_EXTENSIONS = ["pdf", "jpg", "jpeg", "png"];
export const ATTACHMENT_REFERENCE_DOCUMENT_MAX_COUNT = 5;

// constants for ai analysis
export const ATTACHMENT_AI_ANALYSIS_DOCUMENT_ALLOWED_EXTENSIONS = ["jpeg", "pdf", "png", "docx"];
